module.exports = __webpack_public_path__ + "img/li.647f9cdc.svg";